import React from "react";
import MainFeature1 from "components/features/TwoColWithButton.js";
import { useTranslation } from "react-i18next";
import serviceSupportImg from "images/business/service-support.svg";
import businessbgImg from "images/business/informed_decision.svg";
import collaboratorsImg from "images/business/collaborators.svg";

export default () => {
  const { t } = useTranslation(); // Use localization
  return (
    <div>
      {t("business.chineseMarketSupport.services", { returnObjects: true }).map(
        (service, index) => (
          <MainFeature1
            textOnLeft={index % 2 === 0 ? true : false}
            key={index}
            heading={service.title}
            buttonRounded={true}
            primaryButtonText="Join"
            imageSrc={
              index === 0
                ? serviceSupportImg
                : index === 1
                ? businessbgImg
                : collaboratorsImg
            }
            lists={service.lists}
          />
        )
      )}
    </div>
  );
};
